var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 13C14.72 13 16.37 12.31 17.59 11.09C18.81 9.87 19.5 8.22 19.5 6.5C19.5 4.77 18.81 3.12 17.59 1.9C16.37 0.68 14.72 0 13 0C11.27 0 9.62 0.68 8.4 1.9C7.18 3.12 6.5 4.77 6.5 6.5C6.5 8.22 7.18 9.87 8.4 11.09C9.62 12.31 11.27 13 13 13ZM17.33 6.5C17.33 7.64 16.87 8.75 16.06 9.56C15.25 10.37 14.14 10.83 13 10.83C11.85 10.83 10.74 10.37 9.93 9.56C9.12 8.75 8.66 7.64 8.66 6.5C8.66 5.35 9.12 4.24 9.93 3.43C10.74 2.62 11.85 2.16 13 2.16C14.14 2.16 15.25 2.62 16.06 3.43C16.87 4.24 17.33 5.35 17.33 6.5ZM26 23.83C26 26 23.83 26 23.83 26L2.16 26C2.16 26 0 26 0 23.83C0 21.66 2.16 15.16 13 15.16C23.83 15.16 26 21.66 26 23.83ZM23.83 23.82C23.83 23.29 23.49 21.68 22.03 20.21C20.61 18.8 17.95 17.33 13 17.33C8.03 17.33 5.38 18.8 3.96 20.21C2.5 21.68 2.17 23.29 2.16 23.82L23.83 23.82Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico_profile.f86548f4ceb0e8a62a773d8d8a532025.svg";
export { ForwardRef as ReactComponent };